import React from 'react'
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'
import SimpleBar from 'simplebar-react'

import { STATIC_BLOCKS, INTERACTIVE_BLOCKS } from '../../../Editor/Blocks/BlockSettings'
import BLOCK from '../../../../../../common/constants/BlockTypes/BlocksEnum'

import PanelHeader from '../components/PanelHeader.jsx'
import Templates from './components/Templates/Templates'

import { API__TEMPLATES } from '../../../../../../api'

import i18n from '../../../../../../i18n'

const BLOCKS = [
    {
        label: i18n.t('Static'),
        blocks: STATIC_BLOCKS,
    },
    {
        label: i18n.t('Interactive'),
        blocks: INTERACTIVE_BLOCKS,
    },
]

class BlocksPane extends React.Component {
    wrapperRef = React.createRef()
    panelScrollRef = React.createRef()

    constructor(props) {
        super(props)
        this.state = {
            templatesPanel: {
                isOpen: false,
                block: null,
                isLoading: false,
                lastResponse: null,
                requestParams: {
                    sort: 'orderNumber,asc',
                    page: 0,
                    size: 8,
                },
                list: [],
            },
        }
        this.baseState = this.state
    }

    onAdd = async (block, data) => {
        const { onAdd, insertBeforeId, getDecodedObject, openAssetManager } = this.props

        if (data) {
            onAdd(parseInt(block.t), insertBeforeId, getDecodedObject(data))
            this.setState({
                templatesPanel: {
                    ...this.baseState.templatesPanel,
                    isOpen: false,
                    block: null,
                },
            })
            return
        }

        if (block.hasTemplates) {
            try {
                this.setState(prevState => ({
                    templatesPanel: {
                        ...prevState.templatesPanel,
                        isOpen: true,
                        block,
                        isLoading: true,
                        lastResponse: null,
                        list: [],
                    },
                }))
                const {
                    templatesPanel: { requestParams },
                } = this.state
                const response = await API__TEMPLATES.GET_BLOCK_TEMPLATES(block.t, requestParams)
                this.setState(prevState => ({
                    templatesPanel: {
                        ...prevState.templatesPanel,
                        lastResponse: response,
                        list: response.content,
                    },
                }))
            } catch (err) {
                console.error(err)
            } finally {
                this.setState(prevState => ({
                    templatesPanel: {
                        ...prevState.templatesPanel,
                        isLoading: false,
                    },
                }))
            }
            return
        } else {
            if (block.t === BLOCK.image) {
                openAssetManager(_data => this.onAdd(block, { url: _data.src }))
                return
            }
        }

        onAdd(block.t, insertBeforeId)
        this.setState({
            templatesPanel: {
                isOpen: false,
                block: null,
            },
        })
    }

    loadMoreTemplates = async () => {
        try {
            const { templatesPanel } = this.state
            this.setState(prevState => ({
                templatesPanel: {
                    ...prevState.templatesPanel,
                    isLoading: true,
                },
            }))
            const response = await API__TEMPLATES.GET_BLOCK_TEMPLATES(templatesPanel.block.t, {
                ...templatesPanel.requestParams,
                page: templatesPanel.lastResponse.number + 1,
            })
            this.setState(prevState => ({
                templatesPanel: {
                    ...prevState.templatesPanel,
                    lastResponse: response,
                    list: [...prevState.templatesPanel.list, ...response.content],
                },
            }))
        } catch (err) {
            console.error(err)
        } finally {
            this.setState(prevState => ({
                templatesPanel: {
                    ...prevState.templatesPanel,
                    isLoading: false,
                },
            }))
        }
    }

    onClose = () => {
        const { onClose } = this.props

        this.setState({
            templatesPanel: {
                ...this.baseState.templatesPanel,
                isOpen: false,
                block: null,
            },
        })
        onClose()
    }

    render() {
        const { open } = this.props
        const { templatesPanel } = this.state

        if (open) {
            disableBodyScroll(this.wrapperRef.current, { reserveScrollBarGap: true })
        } else {
            clearAllBodyScrollLocks()
        }

        return (
            <>
                <div className={`editor-panel editor-panel--blocks${open ? ' is-opened' : ''}`} ref={this.wrapperRef}>
                    <PanelHeader blockName={i18n.t('All blocks')} scrollRef={this.panelScrollRef} />
                    <div className="close" onClick={this.onClose}></div>
                    <SimpleBar
                        className="blocks-content"
                        autoHide={false}
                        scrollableNodeProps={{ ref: this.panelScrollRef }}
                    >
                        <ul className="list">
                            {BLOCKS &&
                                BLOCKS.map((group, i) => {
                                    const getStyles = block => {
                                        const styles = {}
                                        if (
                                            templatesPanel.isOpen &&
                                            templatesPanel.block &&
                                            templatesPanel.block.t === block.t
                                        ) {
                                            styles.borderColor = block.color
                                        }
                                        return styles
                                    }

                                    return (
                                        <li key={i}>
                                            {group.label && <p className="label">{group.label}</p>}
                                            {group.blocks.length ? (
                                                <ul className="inner-list">
                                                    {group.blocks.map(block => {
                                                        return (
                                                            <li
                                                                key={block.t}
                                                                className={`${
                                                                    block.iconActive
                                                                        ? ' editor-panel--blocks--has-active-icon'
                                                                        : ''
                                                                }${block.hasTemplates ? ' can-collapse' : ''}`}
                                                                style={getStyles(block)}
                                                                onClick={() => this.onAdd(block)}
                                                            >
                                                                {block.icon ? (
                                                                    <div className="img">
                                                                        <img src={block.icon} alt="icon"></img>
                                                                    </div>
                                                                ) : null}
                                                                {block.iconActive ? (
                                                                    <div className="img img--active">
                                                                        <img src={block.iconActive} alt="icon"></img>
                                                                    </div>
                                                                ) : null}
                                                                <p>{block.label}</p>
                                                            </li>
                                                        )
                                                    })}
                                                </ul>
                                            ) : null}
                                        </li>
                                    )
                                })}
                        </ul>
                    </SimpleBar>

                    {open && templatesPanel.isOpen ? (
                        <Templates
                            methods={{
                                loadMore: this.loadMoreTemplates,
                            }}
                            canLoadMore={templatesPanel.lastResponse && !templatesPanel.lastResponse.last}
                            title={templatesPanel.block.templatesTitle}
                            list={templatesPanel.list}
                            block={templatesPanel.block}
                            onAdd={this.onAdd}
                            isLoading={templatesPanel.isLoading}
                        />
                    ) : null}
                </div>
                {open ? <div className="editor-panel-overlay" onClick={this.onClose}></div> : null}
            </>
        )
    }
}

export default BlocksPane
